import renderItemNode from './renderitemnode.js';
import triggerOne from '../../trigger/_triggerone.js';
import forEach from '../../_helpers/foreach.js';
import checkAlreadyRendered from './checkalreadyrendered.js';
import getAlreadyRendered from './getalreadyrendered.js';
import privateKey from '../../_helpers/privatekey.js';
// the index where splice inserted the items; a symbol, so it never clashes with user's event options
export var spliceStart = privateKey('spliceStart');
// the function handles rendering of added items passed as third and rest arguments to splice method
export default function processSpliceAdd(_ref) {
  var self = _ref.self,
    selfDef = _ref.selfDef,
    eventOptions = _ref.eventOptions,
    container = _ref.container;
  var added = eventOptions.added,
    silent = eventOptions.silent;
  var nextNode;
  // find the first rendered node after the last added item to insert newly rendered items before it;
  // a node out of the container (the container was rebound) doesn't count
  for (var i = eventOptions[spliceStart] + added.length; i < self.length && !nextNode; i++) {
    var next = self[i];
    if (next && typeof next === 'object') {
      var node = getAlreadyRendered({
        item: next,
        selfDef: selfDef
      });
      if (node && node.parentNode === container) {
        nextNode = node;
      }
    }
  }
  forEach(added, function (item) {
    if (item && typeof item === 'object') {
      // an item the same splice removes keeps its node, which only moves
      var kept = !!eventOptions.removed && eventOptions.removed.indexOf(item) !== -1 && getAlreadyRendered({
        item: item,
        selfDef: selfDef
      });
      if (kept) {
        if (nextNode) {
          container.insertBefore(kept, nextNode);
        } else {
          container.appendChild(kept);
        }
        return;
      }
      // throw an error if node of an item is alread rendered
      checkAlreadyRendered({
        item: item,
        selfDef: selfDef
      });
      var _renderItemNode = renderItemNode({
          selfDef: selfDef,
          self: self,
          item: item,
          eventOptions: eventOptions
        }),
        _node = _renderItemNode.node,
        itemEventOptions = _renderItemNode.itemEventOptions;
      if (_node) {
        if (nextNode) {
          container.insertBefore(_node, nextNode);
        } else {
          container.appendChild(_node);
        }
        if (!silent) {
          triggerOne(item, 'afterrender', itemEventOptions);
        }
      }
    }
  });
}